<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'CourseOrderGetVo' : 'CourseOrderAddVo'"
            :data="tmpCourseOrder" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateCourseOrder"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateCourseOrderLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{courseOrder.order_no}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== courseOrder.order_no"
          @click="onDeleteCourseOrder"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteCourseOrderLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'CourseOrder',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpCourseOrder: {},
      updateCourseOrderLoading: false,
      deleteCourseOrderLoading: false,
      appFormKey: generateGUID(),
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      courseOrder: state => state.course.courseOrder,
    }),
  },
  methods: {
    ...mapActions({
      getCourseOrder: 'course/getCourseOrder',
      updateCourseOrder: 'course/updateCourseOrder',
      addCourseOrder: 'course/addCourseOrder',
      deleteCourseOrder: 'course/deleteCourseOrder',
    }),
    ...mapMutations({
      setCourseOrder: 'course/setCourseOrder',
    }),
    goBack() {
      this.$router.go(-1)
    },
    onFormChange (data) {
      this.tmpCourseOrder = {...data}
    },
    onAddOrUpdateCourseOrder () {
      if (this.tmpCourseOrder.id) {
        this.updateCourseOrderLoading = true
        this.updateCourseOrder(this.tmpCourseOrder)
          .then(() => {
            this.updateCourseOrderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateCourseOrderLoading = false
          })
      } else {
        this.updateCourseOrderLoading = true
        this.addCourseOrder(this.tmpCourseOrder)
          .then(() => {
            this.updateCourseOrderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateCourseOrderLoading = false
          })
      }
    },
    onDeleteCourseOrder () {
      this.deleteCourseOrderLoading = true
      this.deleteCourseOrder(this.courseOrder.id)
          .then(() => {
            this.deleteCourseOrderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteCourseOrderLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getCourseOrder(this.$route.params.id).then(() => {
        this.tmpCourseOrder = this.courseOrder
      })
    }
  },
  destroyed() {
    this.setCourseOrder({})
  }
}
</script>
